/**
 * Created by Jerker Nord on 2024-01-26.
 */
import {Loner} from "../../../Loner";
import {LonerGameAssets} from "../../../LonerGameAssets";
import {BasicBitmapCountUp} from "../../../components/BasicBitmapCountUp";
import {gsap} from "gsap";
import {SSDBitmapCountup} from "./SSDBitmapCountup";
import {LonerSound} from "../../../sound/LonerSound";

export class LonerSSDMultiplier extends PIXI.Container {

    private static MULTIPLIER_TEXT_CONTAINER_POSITION: PIXI.Point = new PIXI.Point(-36, 10);
    private static MULTIPLIER_HOLDER_POSITION: PIXI.Point = new PIXI.Point(110, 60);

    private _multiplierTextContainer: PIXI.Container;
    private _multiplierContainer: PIXI.Container;
    private _multiplierHolder: PIXI.Sprite;
    private _multiplierValue: number = 0;
    private _multiplierTextGreen: SSDBitmapCountup;
    private _multiplierTextRed: PIXI.BitmapText;
    private _countUpTL: gsap.core.Timeline;

    constructor() {
        super();
        this.init();
    }

    private init(): void {
        this._multiplierContainer = new PIXI.Container();
        this.addChild(this._multiplierContainer);

        this._multiplierHolder = new PIXI.Sprite(Loner.assetLoader.getTextures(LonerGameAssets.SSD_MULTIPLIER_HOLDER)[0]);
        this._multiplierHolder.angle = 186;
        this._multiplierHolder.position = LonerSSDMultiplier.MULTIPLIER_HOLDER_POSITION;
        this._multiplierContainer.addChild(this._multiplierHolder);

        this._multiplierTextContainer = new PIXI.Container();
        this._multiplierTextContainer.position = LonerSSDMultiplier.MULTIPLIER_TEXT_CONTAINER_POSITION;
        this._multiplierContainer.addChild(this._multiplierTextContainer);


        this._multiplierTextRed = new PIXI.BitmapText("x0", {
            fontName: LonerGameAssets.BITMAP_FONT_SSD_RED,
            fontSize: 36
        });
        this._multiplierTextRed.anchor = new PIXI.Point(1, 0.5);
        this._multiplierTextRed.visible = true;
        this._multiplierTextRed.position.x = 107;
        this._multiplierTextRed.position.y = -5;
        this._multiplierTextContainer.addChild(this._multiplierTextRed);

        this._multiplierTextGreen = new SSDBitmapCountup({
            fontName: LonerGameAssets.BITMAP_FONT_SSD_GREEN,
            fontSize: 36,
            tint: 0xffffff
        }, 1000, new PIXI.Point(1, 0.5));
        this._multiplierTextGreen.visible = false;
        this._multiplierTextGreen.position.set(110, -1);
        this._multiplierTextContainer.addChild(this._multiplierTextGreen);

        this.setMultiplierValue(0);
    }

    public addToMultiplier(addValue: number): void {
        if (addValue < 1){
            return;
        }

        if (this._countUpTL && this._countUpTL.isActive()){
            this._countUpTL.totalProgress(1);
            this._countUpTL.kill();
        }

        this._countUpTL = gsap.timeline();
        this._countUpTL.add(gsap.timeline({delay:0.4}));
        this._countUpTL.add(()=>{
            this._multiplierTextGreen.forceSetText("x" + this._multiplierValue);
            this._multiplierTextGreen.visible = true;
            this._multiplierTextRed.visible = false;
            if ((this._multiplierValue + addValue).toString().length > 4){
                this._multiplierTextContainer.scale.set(0.8, 0.8);
                this._multiplierTextContainer.position.x = LonerSSDMultiplier.MULTIPLIER_TEXT_CONTAINER_POSITION.x + 20;
            }
        })
        if (addValue > 10){
            this._countUpTL.add(()=>{
                Loner.soundPlayer.startSSDCountUp();
            });
            this._countUpTL.add(this._multiplierTextGreen.getCountAnimation(this._multiplierValue, (this._multiplierValue + addValue), 1));
            this._countUpTL.add(()=>{
                Loner.soundPlayer.stopSSDCountUp();
            });
            this._countUpTL.add(() => {
                this._multiplierValue += addValue;
                this._multiplierTextGreen.forceSetText("x" + this._multiplierValue);
            });
        }else {
            this._countUpTL.add(() => {
                Loner.soundPlayer.playSound(LonerSound.SSD_COUNTUP_END);
                this._multiplierValue += addValue;
                this._multiplierTextGreen.forceSetText("x" + this._multiplierValue);
            });
        }
        this._countUpTL.add(gsap.timeline({delay:0.6}));
        this._countUpTL.add(()=>{
            this._multiplierTextRed.text = "x" + this._multiplierValue;
            this._multiplierTextRed.visible = true;
            this._multiplierTextGreen.visible = false;
        });
    }

    public setMultiplierValue(setValue: number): void {
        if (setValue.toString().length > 4){
            this._multiplierTextContainer.scale.set(0.8, 0.8);
            this._multiplierTextContainer.position.x = LonerSSDMultiplier.MULTIPLIER_TEXT_CONTAINER_POSITION.x + 20;
        }
        this._multiplierValue = setValue;
        this._multiplierTextGreen.forceSetText("x" + setValue.toString());
        this._multiplierTextRed.text = "x" + setValue.toString();
    }

    public reset(): void {
        this._multiplierTextGreen.forceSetText("x" + 0);
        this._multiplierTextRed.text = "x0";
        this._multiplierValue = 0;
        this._multiplierTextContainer.position.x = LonerSSDMultiplier.MULTIPLIER_TEXT_CONTAINER_POSITION.x;
    }
}